<template>
  <div>
    <!-- <div class="member_tabbar">
      <a href="javascript:;" :class="{'active': curTitle == 1}" @click="changeTitle(1)">学习记录<i></i></a>
      <a href="javascript:;" :class="{'active': curTitle == 2}" @click="changeTitle(2)">我的收藏<i></i></a>
    </div> -->
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <component :is="child"></component>
    </div>
  </div>
</template>

<script>
import {ApiGetTaskList} from '../../net/accound/index.js'
import accnav from '../../common/accnav.vue'
import record from './children/record.vue'
import collection from './children/collection.vue'
import wrong from './children/wrong.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //  1 学习记录   2 我的收藏  3重点课程
      navList: [{
        id: 1,
        name: '学习记录',
      },{
        id: 2,
        name: '我的收藏',
      },{
        id: 4,
        name: '已获证书',
      }],
      loading: false,
    }
  },
  computed: {
    child: function () {
      switch (this.curTitleId) {
        case 1:
         return record
         break
        case 2:
         return collection
         break
        case 3:
         return wrong
         break
        case 4:
         return wrong
         break
        case 5:
         return wrong
         break
      }
    }
  },
  components:{accnav},
  methods:{
    titleChange: function (id) {
      this.curTitleId = id
    },
    toCourseDetail: function (id) {
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .task_list{
    position: relative;
  }
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccMyStudy/AccMyStudy.vue